import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRefPipelines = createRouteRef({
  id: 'tonkean-circleci-plugin',
});

export const rootRouteRefVersions = createRouteRef({
  id: 'tonkean-versions',
});

export const rootRouteRefReports = createRouteRef({
  id: 'tonkean-reports',
});

export const rootRouteRefReleases = createRouteRef({
  id: 'tonkean-releases',
});
